import { render, staticRenderFns } from "./stockViewer.vue?vue&type=template&id=3c5818b2"
import script from "./stockViewer.vue?vue&type=script&lang=js"
export * from "./stockViewer.vue?vue&type=script&lang=js"
import style0 from "./stockViewer.vue?vue&type=style&index=0&id=3c5818b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports